import { useState } from 'react';

/**
 * Lightweight stub — real usage tracking can be restored from git history.
 */
export default function useUsageTracking(_userId) {
  const [showMilestonePrompt] = useState(false);
  return {
    showMilestonePrompt,
    currentMilestone: null,
    dismissMilestonePrompt: () => {},
    sessionsCount: 0
  };
}
